import axios from "axios";
import * as types from "./mutation_types";

export const getItems = ({ commit }) => {
  commit(types.FORMATION_TOGGLE_LOADING);
  axios
    .get("api/formations/partenaire/")
    .then((response) => {
      commit(types.FORMATION_TOGGLE_LOADING);
      commit(types.FORMATION_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.FORMATION_TOGGLE_LOADING);
      commit(types.FORMATION_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.FORMATION_RESET);
};
